import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
import { useParams } from "react-router";
import Select from "react-select";

import "react-datepicker/dist/react-datepicker.css";
import { matchPath } from "react-router";
import config from "config.json";
import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import OffersApply from "components/OffersApply";
import { useForm, Controller } from "react-hook-form";

import {
  createOffer,
  putOffer,
  getOfferById,
  getOfferApplyByAccount,
} from "services/offer_service";

function App() {
  const { register, handleSubmit, setValue, getValues, control } = useForm({});
  const navigate = useNavigate();
  const divRef = useRef(null);

  const [refresh, setRefresh] = useState(true);

  const [isCandidate, setIsCandidate] = useState(false);
  const [offerType, setOfferType] = useState(null);
  const { offerId, candidateId } = useParams();
  const [creatorId, setCreatorId] = useState(null);
  const [creatorName, setCreatorName] = useState(null);
  const [teamList, setTeamList] = useState([]);
  const [playerofferType, setPlayerOfferType] = useState(null); // need to have seperate to make sure that react rerenders the position thingy

  useEffect(() => {
    async function fetchData() {
      let teamArray = JSON.parse(localStorage.getItem("teamIDs"));
      setTeamList(teamArray);

      if (!offerId) return;
      let offer = await getOfferById(offerId);
      let offerApplyList = await getOfferApplyByAccount(
        offerId,
        localStorage.getItem("accountId")
      );

      if (
        offerApplyList.length > 0 ||
        !!matchPath(window.location.pathname, "/ofertas/:id/candidatar") ||
        candidateId
      ) {
        setIsCandidate(true);
      }

      setCreatorId(offer?.attributes?.creator?.data?.id);
      setCreatorName(offer?.attributes?.creator?.data?.attributes?.name);
      setOfferType(offer.attributes.role);

      setValue("role", offer?.attributes?.role);
      setValue("sub_role", offer?.attributes?.sub_role);
      setValue("level", offer?.attributes?.level);
      setValue("division", offer?.attributes?.division);
      setValue("offer_type", offer?.attributes?.offer_type);
      setValue(
        "salary",
        offer?.attributes?.salary ? offer?.attributes?.salary : 0
      );

      setValue("work_type", offer?.attributes?.work_type);
      setValue("club", offer?.attributes?.club);
      setValue("contact", offer?.attributes?.contact);
      setValue("description", offer?.attributes?.description);
      setValue("player_position", offer?.attributes?.player_position);
      setPlayerOfferType(offer?.attributes?.offer_type);
    }
    fetchData();
  }, []);

  const isDisabled = () => {
    return (
      candidateId ||
      (creatorId &&
        localStorage.getItem("accountId") &&
        offerId &&
        "" + creatorId !== "" + localStorage.getItem("accountId"))
    );
  };

  const isOwner = () => {
    return (
      creatorId &&
      offerId &&
      "" + creatorId === "" + localStorage.getItem("accountId")
    );
  };

  const closeOffer = () => {
    putOffer(offerId, { status: "Terminado" });
    navigate("/ofertas");
  };

  const scrollToEnd = () => {
    console.log('scroll to endddd')
    divRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'end'
    });

  };

  const submitForm = async (data) => {
    getValues("role");
    data = {
      ...data,
      creator: localStorage.getItem("accountId"),
    };

    if (!creatorId) {
      await createOffer(data);
    } else {
      await putOffer(offerId, data);
    }
    navigate("/ofertas");
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/ofertas"}>Vagas</Link> /{" "}
              </ul>
            </nav>
            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Vagas</h1>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit((data) => submitForm(data))}>
              <div className="block">
                <div className="field">
                  <label className="label">Clube</label>
                  <p className="control">
                    {creatorId
                      ? creatorName
                      : localStorage.getItem("accountName")}
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Cargo</label>
                  <Controller
                    name="role"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        isDisabled={isDisabled()}
                        options={config.CLUB_INSIDE_ROLES}
                        value={config.CLUB_INSIDE_ROLES.find(
                          (c) => c.value === value
                        )}
                        onChange={(val) => {
                          onChange(val.value);
                          setOfferType(val.value);
                        }}
                      />
                    )}
                  />
                </div>
              </div>
              {offerType === "Jogador" && (
                <>
                  <div className="block">
                    <div className="field">
                      <label className="label">Tipo de vaga</label>
                      <Controller
                        name="offer_type"
                        disabled={isDisabled()}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            options={config.JOB_OFFER_TYPE}
                            isDisabled={isDisabled()}
                            onChange={(val) => {
                              setRefresh(!refresh); // must set to have a refresh when setting this up
                              setPlayerOfferType(val.value);
                              onChange(val.value);
                            }}
                            value={config.JOB_OFFER_TYPE.find(
                              (c) => c.value === value
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  {playerofferType === "Vaga única" && (
                    <div className="block">
                      <div className="field">
                        <label className="label">Posição</label>
                        <Controller
                          name="player_position"
                          disabled={isDisabled()}
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <Select
                              options={config.POSITIONS_PLAYER}
                              isDisabled={isDisabled()}
                              onChange={(val) => {
                                setRefresh(!refresh); // must set to have a refresh when setting this up
                                onChange(val.value);
                              }}
                              value={config.POSITIONS_PLAYER.find(
                                (c) => c.value === value
                              )}
                            />
                          )}
                        />
                      </div>
                    </div>
                  )}
                  <div className="block">
                    <div className="field">
                      <label className="label">Divisão</label>
                      <input
                        className="input"
                        type="text"
                        disabled={isDisabled()}
                        {...register("division", {
                          required: true,
                          minLength: 5,
                        })}
                        placeholder="1º Divisão"
                      />
                    </div>
                  </div>
                </>
              )}
              {offerType === "Treinador" && (
                <>
                  <div className="block">
                    <div className="field">
                      <label className="label">Função</label>
                      <Controller
                        name="sub_role"
                        control={control}
                        disabled={isDisabled()}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            options={config.MANAGER_SUB_ROLES}
                            isDisabled={isDisabled()}
                            onChange={(val) => {
                              onChange(val.value);
                            }}
                            value={config.MANAGER_SUB_ROLES.find(
                              (c) => c.value === value
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Divisão</label>
                      <input
                        className="input"
                        type="text"
                        disabled={isDisabled()}
                        {...register("division", {
                          required: true,
                          minLength: 5,
                        })}
                        placeholder="1º Divisão"
                      />
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Part Time / Full Time</label>
                      <Controller
                        name="work_type"
                        control={control}
                        disabled={isDisabled()}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            options={config.WORK_TYPE}
                            isDisabled={isDisabled()}
                            onChange={(val) => {
                              onChange(val.value);
                            }}
                            value={config.WORK_TYPE.find(
                              (c) => c.value === value
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Salário mensal</label>
                      <Controller
                        name="salary"
                        control={control}
                        disabled={isDisabled()}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            options={config.SALARY_ENUM}
                            isDisabled={isDisabled()}
                            onChange={(val) => {
                              onChange(val.value);
                            }}
                            value={config.SALARY_ENUM.find(
                              (c) => c.value === value
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                </>
              )}
              {offerType === "Outro" && (
                <>
                  <div className="block">
                    <div className="field">
                      <label className="label">Função</label>
                      <Controller
                        name="sub_role"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            isDisabled={isDisabled()}
                            options={config.POSITIONS_OTHER}
                            onChange={(val) => {
                              onChange(val.value);
                            }}
                            value={config.POSITIONS_OTHER.find(
                              (c) => c.value === value
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Salário mensal</label>
                      <Controller
                        name="salary"
                        control={control}
                        disabled={isDisabled()}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            options={config.SALARY_ENUM}
                            isDisabled={isDisabled()}
                            onChange={(val) => {
                              onChange(val.value);
                            }}
                            value={config.SALARY_ENUM.find(
                              (c) => c.value === value
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Part Time / Full Time</label>
                      <Controller
                        name="work_type"
                        control={control}
                        disabled={isDisabled()}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            options={config.WORK_TYPE}
                            isDisabled={isDisabled()}
                            onChange={(val) => {
                              onChange(val.value);
                            }}
                            value={config.WORK_TYPE.find(
                              (c) => c.value === value
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="block">
                <div className="field">
                  <label className="label">Notas Adicionais</label>
                  <p className="control">
                    <textarea
                      disabled={isDisabled()}
                      className="textarea"
                      type="text"
                      rows="7"
                      {...register("description", {
                        required: true,
                        minLength: 5,
                        maxLength: 300,
                      })}
                      placeholder={
                        "Precisamos de um treinadores para a equipa sub-21. A posição é renumerada e deverá ter disponibilidade a começar dia 1 de Agosto."
                      }
                    ></textarea>
                  </p>
                </div>
              </div>
              {!candidateId && (!offerId || (!isCandidate && isOwner())) && (
                <button className="button">Guardar</button>
              )}
              {!candidateId && isOwner() && (
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Link
                    className="button"
                    to={`/ofertas/${offerId}/candidaturas`}
                  >
                    Ver Candidaturas
                  </Link>
                </span>
              )}
              {!candidateId && !isCandidate && isOwner() && (
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <button onClick={() => closeOffer()} className="button">
                    Fechar Oferta
                  </button>
                </span>
              )}
              {!isCandidate &&
                offerId &&
                !isOwner() &&
                localStorage.getItem("role") !== "Clube" && (
                  <span
                    onClick={() => {
                      setIsCandidate(!isCandidate);
                      setTimeout(scrollToEnd, 250);
                    }}
                    className="button"
                  >
                    Candidatar-me à oferta
                  </span>
                )}
              &nbsp;&nbsp;&nbsp;&nbsp;
            </form>
            &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
            {isCandidate && <OffersApply  />}
            <div className="highmam" ref={divRef}></div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
